/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericTableResponse } from '../../models/generic-table-response';

export interface GetTopDestinationAddressesInPeriod$Params {

/**
 * a parameter to filter out cases destination addresses based on the period. E.g. last 7 days
 */
  period: number;

/**
 * a parameter to limit found destination addresses. E.g. top 5
 */
  limit: number;
}

export function getTopDestinationAddressesInPeriod(http: HttpClient, rootUrl: string, params: GetTopDestinationAddressesInPeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
  const rb = new RequestBuilder(rootUrl, getTopDestinationAddressesInPeriod.PATH, 'get');
  if (params) {
    rb.query('period', params.period, {"style":"form","explode":true});
    rb.query('limit', params.limit, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericTableResponse>;
    })
  );
}

getTopDestinationAddressesInPeriod.PATH = '/api/v1/statistics-dashboard/top_destination_addresses';
